import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'

import { datatableSelectors } from './store'

type Props = {
	onChange: (value: any) => void
	dataKey: string
	multiple?: boolean
}

const PLACEHOLDER_VALUE = 'none'

const DatatableSelectFilter = ({ dataKey, onChange, multiple }: Props) => {
	const [open, setOpen] = useState(false)
	const [value, setValue] = useState('')
	const filter = useSelector(datatableSelectors.getFilter(dataKey))

	useEffect(() => {
		setValue((filter?.value as string) || (filter?.placeholder ? PLACEHOLDER_VALUE : ''))
	}, [filter.value])

	const handleChange = (e: React.ChangeEvent<{ name?: string; value: any }>) => {
		const selectValue = e.target.value
		if (selectValue === PLACEHOLDER_VALUE) {
			return
		}
		onChange(selectValue)
		setValue(selectValue)
	}

	const disabled = filter ? filter.disabled || [] : []

	const handleOpen = (v: boolean) => () => setOpen(v)

	return (
		<FormControl fullWidth={true}>
			<Select
				fullWidth={true}
				open={open}
				onClose={handleOpen(false)}
				onOpen={handleOpen(true)}
				value={value}
				onChange={handleChange}
				multiple={multiple}
				title={dataKey}
			>
				{filter?.placeholder && (
					<MenuItem value={PLACEHOLDER_VALUE} disabled={true}>
						{filter.placeholder}
					</MenuItem>
				)}
				{filter &&
					filter.options?.map((item) => (
						<MenuItem key={item.value} value={item.value} disabled={disabled.indexOf(item.value) > -1}>
							{item.label}
						</MenuItem>
					))}
			</Select>
		</FormControl>
	)
}

export default DatatableSelectFilter
